import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import ErrorBoundary from '@hocs/errorBoundary.hoc.tsx';
import { store } from '@store/store.ts';

import './fonts.css';

import App from './App';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <Provider store={store}>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </Provider>
    </StrictMode>,
);
